import React from 'react';
import { useIntl } from 'react-intl-next';

import Textfield from '@atlaskit/textfield';
import { ErrorMessage, Field } from '@atlaskit/form';
import { AnalyticsContext } from '@atlaskit/analytics-next';

import { messages } from '../../messages';

export const SUMMARY_PLACEHOLDER = '';

export type TextFieldProps = {
	value?: string;
	label?: string;
	name?: string;
	onChange?: (value: string) => void;
	placeholder?: string;
	testId?: string;
	isRequired?: boolean;
	isDisabled?: boolean;
	isLoading?: boolean;
};

export const TextField = ({
	value,
	label,
	name = 'summary',
	onChange,
	placeholder = SUMMARY_PLACEHOLDER,
	testId = 'work-create-form-text-field',
	isRequired = true,
	isDisabled = false,
	isLoading = false,
}: TextFieldProps) => {
	const { formatMessage } = useIntl();

	const defaultLabel = formatMessage(messages.workCreateCommonSummaryLabel);
	const errorMessage = formatMessage(messages.workCreateCommonSummaryError);
	const aiLoadingPlaceholder = formatMessage(messages.workCreateCommonSummaryAiLoadingPlaceholder);

	return (
		<AnalyticsContext data={{ attributes: { fieldName: `workCreateFormTextField-${name}` } }}>
			<Field
				aria-required={isRequired}
				name={name}
				isRequired={isRequired}
				label={label || defaultLabel}
				testId={testId}
			>
				{({ fieldProps: { id, onChange: formOnChange, ...rest }, error }) => (
					<>
						<Textfield
							key={id}
							{...rest}
							value={value}
							placeholder={isLoading ? aiLoadingPlaceholder : placeholder}
							onChange={(event) => {
								formOnChange(event);
								onChange?.(event.currentTarget.value);
							}}
							isDisabled={isDisabled || isLoading}
						/>
						{error && <ErrorMessage>{errorMessage}</ErrorMessage>}
					</>
				)}
			</Field>
		</AnalyticsContext>
	);
};
